/**
 * Hooks de **marcado / desmarcado** de un número del talonario
 * (`POST /api/v1/talonarios/mark` y `/unmark`).
 *
 * Cada uno envuelve su llamada en un `useMutation`. Tras éxito **invalida las
 * queries de talonarios** (`docs/frontend_conventions.md`, Datos): el grid del
 * trabajador cambia (un número pasa a marcado/disponible), el estado de la lista
 * (ocupados/disponibles) también, y se registra una entrada en el historial. Se
 * invalida la raíz `['talonarios']`. El gating de permiso lo decide la UI; aquí
 * solo se ejecuta y se propaga el `ApiError`.
 */
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { markTalonarioNumber, unmarkTalonarioNumber, type MarkResult } from "../api";
import type { MarkNumberBody } from "../types";
import { TALONARIOS_ROOT_KEY } from "./queryKeys";

export function useMarkNumber() {
  const queryClient = useQueryClient();
  return useMutation<MarkResult, Error, MarkNumberBody>({
    mutationFn: (body) => markTalonarioNumber(body),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: TALONARIOS_ROOT_KEY });
    },
  });
}

export function useUnmarkNumber() {
  const queryClient = useQueryClient();
  return useMutation<MarkResult, Error, MarkNumberBody>({
    mutationFn: (body) => unmarkTalonarioNumber(body),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: TALONARIOS_ROOT_KEY });
    },
  });
}
